import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PLATFORM_STATIC_ICONS_PNG } from '../../../config/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { useEffect, useState } from 'react';
import PlaceholderImage from '../../../assets/images/placeholders/user/user.png';

import {
  addUrl,
  removeConversationFromList,
  setActiveConversation,
  setConversationAttributes,
  updateConversationAttributesLocaly,
  updateNotificationsCount
} from '../../../redux/slices/communication';
import { getImageUrl } from '../../../firebase/utils';

export function TopCard() {
  const { t } = useTranslate();
  const {
    data: { activeConversation, urls }
  } = useSelector((state) => state.communication);

  const [imageUrl, setImageUrl] = useState(null);
  useEffect(() => {
    if (activeConversation?.social_media_platform_user?.image_file)
      if (urls?.[activeConversation?.social_media_platform_user?.image_file])
        setImageUrl(
          urls[activeConversation?.social_media_platform_user?.image_file]
        );
      else
        getImageUrl(activeConversation?.social_media_platform_user?.image_file)
          .then((url) => {
            dispatch(
              addUrl(
                activeConversation?.social_media_platform_user?.image_file,
                url
              )
            );
            setImageUrl(url);
          })
          .catch((err) => console.log(err));
  }, [activeConversation]);

  const [marked, setMarked] = useState(activeConversation?.is_marked);
  const [seen, setSeen] = useState(activeConversation?.read);
  const [spam, setSpam] = useState(activeConversation?.is_spam);
  const [status, setStatus] = useState(activeConversation?.status);
  const dispatch = useDispatch();
  useEffect(() => {
    setMarked(activeConversation?.is_marked);
    setSeen(activeConversation?.read);
    setSpam(activeConversation?.is_spam);
    setStatus(activeConversation?.status);
  }, [activeConversation]);
  const [imageError, setImageError] = useState(false);
  return (
    <div className="card m-2 p-4 shadow d-flex flex-row justify-content-between w-100 align-items-center container row overflow-x-none">
      <div className="d-flex flex-row justify-content-between p-0">
        <div>
          <b className="text-muted m-0 mb-2 p-0 fs-6 fw-bold">
            {t('communication.general_info.general_info')}
          </b>
        </div>
        <div>
          <img
            className="h-20px"
            style={{ zIndex: 99, bottom: 0, right: 6 }}
            src={PLATFORM_STATIC_ICONS_PNG[activeConversation.platform]}
          />
        </div>
      </div>

      <div className="col-4 py-2 d-flex flex-column">
        <div className="position-relative">
          <div>
            {!imageError && imageUrl && (
              <img
                src={imageUrl}
                className="h-50px w-50px img-thumbnail"
                onError={(e) => {
                  // setImage url to null
                  setImageError(true);
                }}
              />
            )}
            {(imageError || !imageUrl) && (
              <img
                src={PlaceholderImage}
                style={{ objectFit: 'cover' }}
                className="h-50px w-50px img-thumbnail"
              />
            )}
          </div>
        </div>
      </div>
      <div className="col-8 p-2 d-flex  justify-content-start flex-column ">
        <OverlayTrigger
          overlay={
            <Tooltip>
              {activeConversation?.social_media_platform_user?.name}
            </Tooltip>
          }
        >
          <p className="fw-bold m-0 text-truncate">
            {activeConversation?.social_media_platform_user?.name}
          </p>
        </OverlayTrigger>
        <p className="fw-bold text-muted m-0">{t(activeConversation.type)}</p>
      </div>
      <div className="d-flex justify-content-between align-items-center w-100 mt-4">
        <div className="d-flex align-items-center">
          <OverlayTrigger
            delay={{ show: 200 }}
            placement="top"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {t('communication.general_info.unread')}
                </span>
              </Tooltip>
            }
          >
            <i
              onClick={() => {
                setSeen(!seen);
                dispatch(
                  setConversationAttributes(activeConversation.uuid, {
                    read: false
                  })
                );
                dispatch(
                  updateConversationAttributesLocaly(activeConversation.uuid, {
                    read: false
                  })
                );
                dispatch(setActiveConversation(null));
                dispatch(
                  updateNotificationsCount(activeConversation.platform, 1)
                );
              }}
              className={
                'shadow-sm p-2 rounded  fa-duotone fa-eye-slash mx-3 cursor-pointer text-dark fs-4'
              }
            ></i>
          </OverlayTrigger>
          <OverlayTrigger
            delay={{ show: 200 }}
            placement="top"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {t('communication.general_info.tooltip_marked')}
                </span>
              </Tooltip>
            }
          >
            <i
              onClick={() => {
                setMarked(!marked);
                dispatch(
                  setConversationAttributes(activeConversation.uuid, {
                    is_marked: !marked
                  })
                );
                dispatch(
                  updateConversationAttributesLocaly(activeConversation.uuid, {
                    is_marked: !marked
                  })
                );
              }}
              className={`shadow-sm p-2 rounded fa-duotone fa-star  cursor-pointer fs-4 ${
                marked ? 'text-warning' : 'text-dark'
              }`}
            ></i>
          </OverlayTrigger>
          <OverlayTrigger
            delay={{ show: 200 }}
            placement="top"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {t('communication.general_info.status_tooltip')}
                </span>
              </Tooltip>
            }
          >
            <i
              onClick={() => {
                setStatus(status ? 0 : 1);
                dispatch(
                  setConversationAttributes(activeConversation.uuid, {
                    status: status ? 0 : 1
                  })
                );
                dispatch(
                  updateConversationAttributesLocaly(activeConversation.uuid, {
                    status: status ? 0 : 1
                  })
                );
                if (!status) {
                  dispatch(setActiveConversation(null));
                  // remove from conversation list
                  dispatch(removeConversationFromList(activeConversation.uuid));
                }
              }}
              className={`shadow-sm p-2 rounded  fa-duotone fa-circle-check mx-3 cursor-pointer fs-4 ${
                status ? 'text-success' : 'text-dark'
              }`}
            ></i>
          </OverlayTrigger>
        </div>
        <div className="d-flex align-items-center">
          <OverlayTrigger
            delay={{ show: 200 }}
            placement="top"
            overlay={
              <Tooltip>
                <span className="text-gray-400 fw-bold d-block fs-7">
                  {t('communication.general_info.spam')}
                </span>
              </Tooltip>
            }
          >
            <i
              onClick={() => {
                dispatch(
                  setConversationAttributes(activeConversation.uuid, {
                    is_spam: !spam
                  })
                );
                dispatch(
                  updateConversationAttributesLocaly(activeConversation.uuid, {
                    is_spam: !spam
                  })
                );
                setSpam(!spam);
                if (!spam) {
                  dispatch(setActiveConversation(null));
                  dispatch(removeConversationFromList(activeConversation.uuid));
                }
              }}
              className={`shadow-sm p-2 rounded  fa-solid fa-octagon-exclamation cursor-pointer fs-3 ${
                spam ? 'text-danger' : ''
              }`}
            ></i>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  );
}
